import React from 'react';
import "./Contact.css";

const Map = () => {
  return (
    <div className='map-content'>
        {/* eslint-disable-next-line */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.471480000581!2d73.04387331480925!3d26.148770298853076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3942207ec550a1e5%3A0x7ce596d865debd49!2sJIET%20Group%20of%20Institutions%2C%20Mogra%20Khurd%2C%20Rajasthan%20342802!5e0!3m2!1sen!2sin!4v1661411101519!5m2!1sen!2sin"  width="100%" height="450" style={{border:0}}></iframe>
    </div>
  )
}

export default Map
